import React, { useState, useEffect, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { SelectChangeEvent } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import { TextComponent, SelectComponent } from '../uiComponents';
import { EnumerationComponent } from '../gritComponents';
import { Claim, Enumeration } from '../../xmlParsing/interfaces';
import { jsonEditorStyles } from './jsonEditorStyles';
import { useSelector, useDispatch } from 'react-redux';
import { getJSONClaims, getJSONAADAttributes, setJSONClaims, setJSONAADAttributes } from '../../store';
import CONSTANTS from '../../constants/constants';
import JSON_CONSTANTS from '../../constants/jsonConstants';
import { OptionProps } from '../../view-models';
import { init_Claim } from '../../xmlParsing/initInterfaces';
import ShowClaimComponent from '../gritComponents/showClaim';
import cn from 'clsx';
interface ClaimComponentProps {
  data: Claim;
  changeHandler: (data: Claim) => void;
}

const userInputTypesByDataType: { [dtype: string]: OptionProps[] } = {
  boolean: [
    { label: 'Clear User Input Type', value: '' },
    { label: 'TextBox', value: 'TextBox' },
    { label: 'Readonly', value: 'Readonly' },
    { label: 'Paragraph', value: 'Paragraph' },
  ],
  string: [
    { label: 'Clear User Input Type', value: '' },
    { label: 'TextBox', value: 'TextBox' },
    { label: 'Readonly', value: 'Readonly' },
    { label: 'RadioSingleSelect', value: 'RadioSingleSelect' },
    { label: 'Password', value: 'Password' },
    { label: 'Paragraph', value: 'Paragraph' },
    { label: 'EmailBox', value: 'EmailBox' },
    { label: 'DropdownSingleSelect', value: 'DropdownSingleSelect' },
    { label: 'CheckboxMultiSelect', value: 'CheckboxMultiSelect' },
  ],
  dateTime: [
    { label: 'Clear User Input Type', value: '' },
    { label: 'Readonly', value: 'Readonly' },
    { label: 'Paragraph', value: 'Paragraph' },
    { label: 'DateTimeDropdown', value: 'DateTimeDropdown' },
  ],
};

function JSONClaimComponent({ data, changeHandler }: ClaimComponentProps) {
  const initData = useRef<Claim>(data);
  const [modifiedData, setModifiedData] = useState<Claim>(init_Claim());
  //   const [applyMask, setApplyMask] = useState<string>('');
  const [showPattern, setShowPattern] = useState<string>('');
  const [selectedClaim, setSelectedClaim] = useState<string>('');
  const [mode, setMode] = useState<string>('add');
  const [claimsList, setClaimsList] = useState<OptionProps[]>([]);
  const [isCreateAttribute, setIsCreateAttribute] = useState(false);
  const [claimError, setClaimError] = useState<string>('Should not be empty');
  const [dispNameError, setDispNameError] = useState<string>('Should not be empty');
  const [maskValueError, setMaskValueError] = useState<string>('');
  const [maskRegexError, setMaskRegexError] = useState<string>('');
  const classes = jsonEditorStyles();
  const allClaims = useSelector(getJSONClaims);
  const allAADAttrs = useSelector(getJSONAADAttributes);
  const dispatch = useDispatch();

  useEffect(() => {
    setModifiedData(data);
  }, [initData]);

  useEffect(() => {
    if (Object.keys(allClaims).length > 0) {
      const _temp = Object.keys(allClaims)
        .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
        .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1));
      setClaimsList(_temp);
      setSelectedClaim(_temp[0]['value']);
    }
  }, [allClaims]);
  useEffect(() => {
    // changeHandler(modifiedData);
    // modifiedData.hasOwnProperty('mask') ? setApplyMask(applyMask || Object.keys(CONSTANTS.MASK)[0]) : setApplyMask('');
    modifiedData.hasOwnProperty('pattern')
      ? setShowPattern(showPattern || Object.keys(CONSTANTS.PATTERN)[0])
      : setShowPattern('');
  }, [modifiedData]);

  const setRestAndMask = (dataType: string, userInputType: string) => {
    const _obj = modifiedData;
    if (dataType !== 'string') {
      delete _obj?.mask;
    }
    delete _obj['pattern'];
    if (
      userInputTypesByDataType[dataType].filter((op) => {
        return op.value === userInputType;
      }).length === 0
    ) {
      userInputType = '';
    }
    if (['CheckboxMultiSelect', 'DropdownSingleSelect', 'RadioSingleSelect'].includes(userInputType)) {
      setModifiedData({
        ..._obj,
        dataType: dataType,
        userInputType: userInputType,
        restriction: 'Enumeration',
        enumeration:
          dataType === 'boolean'
            ? [
                { value: 'true', text: 'True', selectByDefault: false },
                { value: 'false', text: 'False', selectByDefault: false },
              ]
            : _obj['enumeration'] || [],
      });
    } else {
      // TextBox', ', 'Readonly', 'Password', 'Paragraph', 'EmailBox', 'DateTimeDropdown'
      delete _obj['restriction'];
      delete _obj['enumeration'];
      setModifiedData({ ..._obj, dataType: dataType, userInputType: userInputType });
      if (['TextBox'].includes(userInputType)) {
        setShowPattern('');
      }
    }
  };

  const editClaimHandler = (id: string) => {
    setMode('edit');
    setModifiedData(allClaims[id]);
    setClaimError('');
    setDispNameError('');
    setMaskValueError('');
    setMaskRegexError('');
    allAADAttrs.hasOwnProperty('extension_' + id) ? setIsCreateAttribute(true) : setIsCreateAttribute(false);
  };

  return (
    <div className={classes.flexRow}>
      <div className={cn(classes.flexCol, classes.flex, classes.overFlowYScroll)}>
        <div>
          <TextComponent
            changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
              if (e.target.value === '') {
                setClaimError('Should not be empty');
              } else if (!/^[a-zA-Z0-9]+[a-zA-Z0-9_-]{0,}$/.test(e.target.value)) {
                setClaimError(
                  'Should begin with an alphabet or number and can contain alphabets, numbers and the following symbols: _ -',
                );
              } else if (
                Object.keys(allClaims).findIndex(
                  (el: string) => el.trim().toLowerCase() === e.target.value.trim().toLowerCase(),
                ) >= 0
              ) {
                setClaimError('A claimTypeReferenceId exists with the same name');
              } else if (JSON_CONSTANTS.restrictedClaimNames.includes(e.target.value.trim().toLowerCase())) {
                setClaimError('Reserved claimTypeReferenceId cannot be used.');
              } else {
                setClaimError('');
              }
              setModifiedData({ ...modifiedData, id: e.target.value });
            }}
            data={{
              value: modifiedData.id || '',
              label: 'ClaimTypeReferenceId',
              disabled: mode !== 'add',
              error: !!claimError,
              helperText: claimError,
            }}
          />
        </div>
        <div>
          <TextComponent
            changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
              if (e.target.value === '') {
                setDispNameError('Should not be empty');
              } else {
                setDispNameError('');
              }
              setModifiedData({ ...modifiedData, displayName: e.target.value });
            }}
            data={{
              value: modifiedData.displayName || '',
              label: 'Display Name',
              error: !!dispNameError,
              helperText: dispNameError,
            }}
          />
        </div>
        <div>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<string>) => {
              setRestAndMask(e.target.value, modifiedData['userInputType']);
            }}
            data={{
              value: modifiedData['dataType'],
              label: 'Data Type',
              options: [
                { label: 'string', value: 'string' },
                { label: 'boolean', value: 'boolean' },
                { label: 'dateTime', value: 'dateTime' },
              ],
            }}
          />
        </div>
        <div>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<string>) => {
              setRestAndMask(modifiedData['dataType'], e.target.value);
            }}
            data={{
              value: modifiedData['userInputType'] || '',
              label: 'User Input Type',
              options: userInputTypesByDataType[modifiedData['dataType']]
                ? userInputTypesByDataType[modifiedData['dataType']]
                : [],
            }}
          />
        </div>
        <div>
          {['CheckboxMultiSelect', 'DropdownSingleSelect', 'RadioSingleSelect'].includes(
            modifiedData['userInputType'],
          ) &&
            modifiedData['dataType'] === 'string' && (
              <EnumerationComponent
                list={modifiedData?.enumeration || []}
                onChangeEnumeration={(enumData: Enumeration[]) => {
                  setModifiedData({ ...modifiedData, enumeration: enumData });
                }}
              />
            )}
        </div>
        <div>
          {['TextBox'].includes(modifiedData['userInputType']) && modifiedData['dataType'] === 'string' && (
            <div className={classes.flexCol}>
              <div>
                <FormControlLabel
                  sx={{ m: 0 }}
                  label="Validate Pattern"
                  control={
                    <Checkbox
                      checked={!!showPattern}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (!!showPattern) {
                          setShowPattern('');
                          const _obj = modifiedData;
                          delete _obj['restriction'];
                          delete _obj['pattern'];
                          delete _obj['enumeration'];
                          setModifiedData(_obj);
                        } else {
                          const _tempPattern: string = Object.keys(CONSTANTS.PATTERN)[0];
                          setShowPattern(_tempPattern);
                          const _obj = modifiedData;
                          delete _obj['enumeration'];
                          setModifiedData({
                            ..._obj,
                            restriction: 'Pattern',
                            pattern: {
                              // @ts-ignore
                              regularExpression: CONSTANTS.PATTERN[_tempPattern][0],
                              // @ts-ignore
                              helpText: CONSTANTS.PATTERN[_tempPattern][1],
                            },
                          });
                        }
                      }}
                    />
                  }
                />
              </div>
              {!!showPattern && (
                <div className={classes.flexCol}>
                  <SelectComponent
                    changeHandler={(e: SelectChangeEvent<string>) => {
                      setShowPattern(e.target.value);
                      setModifiedData({
                        ...modifiedData,
                        restriction: 'Pattern',
                        pattern: {
                          // @ts-ignore
                          regularExpression: CONSTANTS.PATTERN[e.target.value][0],
                          // @ts-ignore
                          helpText: CONSTANTS.PATTERN[e.target.value][1],
                        },
                      });
                    }}
                    data={{
                      value: showPattern,
                      label: 'Select Pattern',
                      options: Object.keys(CONSTANTS.PATTERN).reduce(
                        (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                        [],
                      ),
                    }}
                  />
                  <TextComponent
                    changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                      setShowPattern('CustomRegex');
                      setModifiedData({
                        ...modifiedData,
                        restriction: 'Pattern',
                        pattern: {
                          regularExpression: e.target.value,
                          helpText: (modifiedData['pattern'] && modifiedData['pattern']['helpText']) || '',
                        },
                      });
                    }}
                    data={{
                      value: (modifiedData['pattern'] && modifiedData['pattern']['regularExpression']) || '',
                      label: 'Regular Expression',
                      error: (modifiedData['pattern'] && modifiedData['pattern']['regularExpression'].trim()) === '',
                      helperText:
                        (modifiedData['pattern'] && modifiedData['pattern']['regularExpression'].trim()) === ''
                          ? 'Enter a valid regular expression'
                          : '',
                    }}
                  />
                  <TextComponent
                    changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                      setModifiedData({
                        ...modifiedData,
                        restriction: 'Pattern',
                        pattern: {
                          regularExpression:
                            (modifiedData['pattern'] && modifiedData['pattern']['regularExpression']) || '',
                          helpText: e.target.value,
                        },
                      });
                    }}
                    data={{
                      value: (modifiedData['pattern'] && modifiedData['pattern']['helpText']) || '',
                      label: 'Help Text',
                      helperText: 'Regex fail message.',
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        <div>
          {modifiedData['dataType'] === 'string' && (
            <div className={classes.flexCol}>
              <SelectComponent
                changeHandler={(e: SelectChangeEvent<string>) => {
                  setModifiedData({
                    ...modifiedData,
                    mask: {
                      type: e.target.value,
                      value: modifiedData['mask'] ? modifiedData['mask'].value : '',
                      regex: modifiedData['mask'] ? modifiedData['mask'].regex : '',
                    },
                  });
                  if (e.target.value === 'Regex' && !modifiedData['mask']?.regex) {
                    setMaskRegexError('Regex expression for regex-type masks cannot be empty');
                    setMaskValueError('');
                  } else if (e.target.value === 'Simple' && !modifiedData['mask']?.value) {
                    setMaskRegexError('');
                    setMaskValueError('Mask string for simple masks cannot be empty');
                  } else {
                    setMaskValueError('');
                    setMaskRegexError('');
                  }
                }}
                data={{
                  value: modifiedData['mask']?.type ? modifiedData['mask'].type : 'None',
                  label: 'Mask',
                  options: [
                    { value: 'None', label: 'None' },
                    { value: 'Simple', label: 'Simple' },
                    { value: 'Regex', label: 'Regex' },
                  ],
                }}
              />
              {modifiedData['mask']?.type && modifiedData['mask'].type !== 'None' && (
                <TextComponent
                  changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                    setModifiedData({
                      ...modifiedData,
                      mask: {
                        type: modifiedData['mask']!.type,
                        value: e.target.value,
                        regex: modifiedData['mask']?.regex ? modifiedData['mask'].regex : '',
                      },
                    });
                    if (modifiedData['mask']?.type === 'Regex' && !modifiedData['mask']?.regex) {
                      setMaskRegexError('Regex expression for regex-type masks cannot be empty');
                      setMaskValueError('');
                    } else if (modifiedData['mask']?.type === 'Simple' && !e.target.value) {
                      setMaskRegexError('');
                      setMaskValueError('Mask string for simple masks cannot be empty');
                    } else {
                      setMaskValueError('');
                      setMaskRegexError('');
                    }
                  }}
                  data={{
                    value: modifiedData['mask']?.value ? modifiedData['mask'].value : '',
                    label: 'Mask Value',
                    error: !!maskValueError,
                    helperText: maskValueError,
                  }}
                />
              )}
              {modifiedData['mask']?.type && modifiedData['mask'].type === 'Regex' && (
                <TextComponent
                  changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                    setModifiedData({
                      ...modifiedData,
                      mask: {
                        type: modifiedData['mask']!.type,
                        value: modifiedData['mask']?.value ? modifiedData['mask'].value : '',
                        regex: e.target.value,
                      },
                    });
                    if (modifiedData['mask']?.type === 'Regex' && !e.target.value) {
                      setMaskRegexError('Regex expression for regex-type masks cannot be empty');
                      setMaskValueError('');
                    } else if (modifiedData['mask']?.type === 'Simple' && !modifiedData['mask']?.value) {
                      setMaskRegexError('');
                      setMaskValueError('Mask string for simple masks cannot be empty');
                    } else {
                      setMaskValueError('');
                      setMaskRegexError('');
                    }
                  }}
                  data={{
                    value: modifiedData['mask']?.regex ? modifiedData['mask'].regex : '',
                    label: 'Mask Regex',
                    error: !!maskRegexError,
                    helperText: maskRegexError,
                  }}
                />
              )}
            </div>
          )}
        </div>
        <div>
          <TextComponent
            changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
              setModifiedData({ ...modifiedData, userHelpText: e.target.value });
            }}
            data={{
              value: modifiedData.userHelpText || '',
              label: 'User Help Text',
            }}
          />
        </div>
        <div>
          <TextComponent
            changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
              setModifiedData({ ...modifiedData, adminHelpText: e.target.value });
            }}
            data={{
              value: modifiedData.adminHelpText || '',
              label: 'Admin Help Text',
            }}
          />
        </div>
        <div>
          {mode === 'add' && (
            <FormControlLabel
              sx={{ m: 0 }}
              label="Create AAD Attribute"
              control={
                <Checkbox
                  checked={isCreateAttribute}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setIsCreateAttribute(!isCreateAttribute);
                  }}
                />
              }
            />
          )}
        </div>
        <div>
          {mode === 'edit' && allAADAttrs.hasOwnProperty('extension_' + modifiedData.id) && (
            <FormControlLabel
              sx={{ m: 0 }}
              label="Update AAD Attribute"
              control={
                <Checkbox
                  checked={isCreateAttribute}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setIsCreateAttribute(!isCreateAttribute);
                  }}
                />
              }
            />
          )}
        </div>
        <div>
          {mode === 'edit' && !allAADAttrs.hasOwnProperty('extension_' + modifiedData.id) && (
            <FormControlLabel
              sx={{ m: 0 }}
              label="Create AAD Attribute"
              control={
                <Checkbox
                  checked={isCreateAttribute}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setIsCreateAttribute(!isCreateAttribute);
                  }}
                />
              }
            />
          )}
        </div>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            setModifiedData(init_Claim());
            setClaimError('Should not be empty');
            setDispNameError('Should not be empty');
            dispatch(setJSONClaims(modifiedData));
            if (isCreateAttribute)
              dispatch(setJSONAADAttributes({ id: 'extension_' + modifiedData.id, dataType: modifiedData.dataType }));
            setMode('add');
            setIsCreateAttribute(false);
          }}
          disabled={!!claimError || !!dispNameError || !!maskRegexError || !!maskValueError}
        >
          {mode === 'add' ? 'Add' : 'Update'}
        </Button>
      </div>
      <div className={classes.flexCol}>
        {claimsList.length === 0 && <div>There are no claims</div>}
        {claimsList.length > 0 && (
          <>
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<string>) => {
                setSelectedClaim(e.target.value);
              }}
              data={{
                value: selectedClaim,
                label: 'Select ClaimTypeReferenceId',
                style: { margin: 1, width: 400 },
                options: claimsList,
              }}
            />
            <ShowClaimComponent data={allClaims[selectedClaim]} editClaim={editClaimHandler} />
          </>
        )}
      </div>
    </div>
  );
}

// export default withAITracking(reactPlugin, JSONClaimComponent);
export default JSONClaimComponent;
